// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3RNQb","label":"Radio_label__3MzAl","checkMark":"Radio_checkMark__1cqeK","disabled":"Radio_disabled__3kuDZ"};